export default __webpack_public_path__ + "static/media/niyama_logo_white_text.b9527405.svg";